const resource = 'order_returns'

export default $axios => ({
  fetch(params) {
    return $axios.$get(`/${resource}`, { params })
  },

  get(id, params) {
    return $axios.$get(`/${resource}/${id}`, { params })
  },

  create(order_id, params) {
    return $axios.$post(`/orders/${order_id}/${resource}`, params)
  },

  cancel(id) {
    return $axios.$patch(`/${resource}/${id}/cancel`)
  },

  fetchAccountOrderReturns() {
    return $axios.$get('/v2/account/order-returns')
  },

  fetchAccountOrderReturn(id) {
    return $axios.$get(`/v2/account/order-returns/${id}`)
  },

  getServiceName: name => 'orderReturnService',
})
